import React from "react";
import { useTranslation } from "react-i18next";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveProjectModels,
} from "@planzone/view-models";
import { zone } from "@planzone/dto";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import { ProjectModel } from "./projectModel";
import { Loader } from "./loader";
import styles from "./styles.scss";

function ProjectModelsPage(_: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    projectModels,
    retrieveProjectModels,
  } = useRetrieveProjectModels();

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectModels(planzone);
  }, []);

  return (
    <div className={styles.projectModelsPage}>
      <div className={styles.toolbar}>
        <button
          className={styles.button}
          onClick={() =>
            pushView({
              key: UseCases.createProject,
              data: { zone: { ...zone, uuid: "" }, isTemplate: true },
            })
          }
        >
          <div className={styles.iconBox}>+</div>
          <p>{t("projectModelsPage.add")}</p>
        </button>
      </div>
      <div className={styles.main}>
        {!isRequestPending ? (
          <div className={styles.models}>
            {projectModels.map((model) => (
              <div key={model.uuid} className={styles.model}>
                <ProjectModel
                  model={{ ...model, isTemplate: true }}
                  useTemplate={() =>
                    pushView({
                      key: UseCases.useProjectModel,
                      data: { model },
                    })
                  }
                />
              </div>
            ))}
          </div>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}

export { ProjectModelsPage };
